export default "__VITE_ASSET__8eYbGSB$__"